module.exports = __webpack_public_path__ + "public/img/Microsoft Excel Untuk Staf Admin.f0b59a9a.png";